<template>
  <section class="layoutLayout weflix-admin-integrationsLayout">
    <TitlePage title="Integrações" subtitle="Personalize suas integrações para seu site" :hasMargin="true" /> 
      <div class="row" v-if="hasReady">
        <div :class="responsiveClassOne">
          <div class="row">

            <div class="col-form-inner col-12 col-md-12 col-lg-12 select integrations">
              <div class="form-group">
                <label class="label-form">Facebook Pixel: </label>
                <div class="form-input">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="GTM-28CJ0"
                    v-model="facebook"
                  />
                  <small class="small">Configure o código do Facebook Pixel para rastrear e analisar o comportamento dos visitantes em seu site.</small>

                </div>
              </div>
            </div>
            <div class="col-form-inner col-12 col-md-12 col-lg-12 select integrations">
              <div class="form-group">
                <label class="label-form">Google Ads Pixel: </label>
                <div class="form-input">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="GTM-28CJ0"
                    v-model="gads"
                  />
                  <small class="small">Configure o código do Google Ads Pixel para rastrear e analisar o comportamento dos visitantes em seu site.</small>

                </div>
              </div>
            </div>
            <div class="col-form-inner col-12 col-md-12 col-lg-12 select integrations">
              <div class="form-group">
                <label class="label-form">Google Analytics Code: </label>
                <div class="form-input">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="GTM-28CJ0"
                    v-model="ganalytic"
                  />
                  <small class="small">Configure o código do Google Analytics para rastrear e analisar o comportamento dos visitantes em seu site.</small>

                </div>
              </div>
            </div>
            <div class="col-form-inner col-12 col-md-12 col-lg-12 select integrations">
              <div class="form-group">
                <label class="label-form">Tag Manager Code: </label>
                <div class="form-input">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="GTM-28CJ0"
                    v-model="tagManager"
                  />
                  <small class="small">Configure o código do Tag Manager para rastrear e analisar o comportamento dos visitantes em seu site.</small>

                </div>
              </div>
            </div>
           
          </div>
        </div>

        <div :class="responsiveClassTwo" >
         
          <div class="col-form-inner col-12 col-md-12 col-lg-12 select integrations">
            <div class="form-group">
              <label class="label-form">RDRefresh Code: </label>
              <div class="form-input">
                <input
                  type="text"
                  class="form-control"
                  placeholder="GTM-28CJ0"
                  v-model="rdrefreshToken"
                />
                <small class="small">Configure o código do RDRefresh para rastrear e analisar o comportamento dos visitantes em seu site.</small>
              </div>
            </div>
          </div>
          
          <div class="col-form-inner col-12 col-md-12 col-lg-12 select integrations">
            <div class="form-group">
              <label class="label-form">RDStation Code: </label>
              <div class="form-input">
                <input
                  type="text"
                  class="form-control"
                  placeholder="GTM-28CJ0"
                  v-model="rdcode"
                />
                <small class="small">Configure o código do RDStation para rastrear e analisar o comportamento dos visitantes em seu site.</small>
              </div>
            </div>
          </div>

          <div class="col-form-inner col-12 col-md-12 col-lg-12 select integrations">
            <div class="form-group">
              <label class="label-form">RDStation Secret Client: </label>
              <div class="form-input">
                <input
                  type="text"
                  class="form-control"
                  placeholder="GTM-28CJ0"
                  v-model="rdSecret"
                />
                <small class="small">Configure o código do RDStation Secret para rastrear e analisar o comportamento dos visitantes em seu site.</small>
              </div>
            </div>
          </div>

          <div class="col-form-inner col-12 col-md-12 col-lg-12 select integrations">
            <div class="form-group">
              <label class="label-form">RDStation Client ID: </label>
              <div class="form-input">
                <input
                  type="text"
                  class="form-control"
                  placeholder="GTM-28CJ0"
                  v-model="rdClient"
                />
                <small class="small">Configure o código do RDStation Client para rastrear e analisar o comportamento dos visitantes em seu site.</small>
              </div>
            </div>
          </div>
            
        </div>
      </div>
      <div class="actionsSave" id="layoutIntegrationsWeflix">
        <v-btn variant="outlined" border="2" color="primary" size="large" width="140" @click="updateIntegrations">Salvar</v-btn>
      </div>
      
  </section>
 
<Loader :hasReady="hasReady" />
</template>
<script>
import websiteApi from '@/utils/Weflix/website';
import { mapState } from 'vuex';
import Loader from '@/components/Weflix/Loader.vue';
import { toast } from 'vue3-toastify';
import TitlePage from '@/components/Weflix/titlePage.vue';

export default {
  data(){
      return{
          facebook: '',
          gads: '',
          ganalytic: '',
          tagManager: '',
          rdrefreshToken: '',
          rdcode: '',
          rdSecret: '',
          rdClient: '',
          hasReady: false,
          descriptionAbout:'',
          windowWidth: window.innerWidth,
      }
  },
  computed: {
    ...mapState(['token', 'layoutWebsite']),
    responsiveClassOne() {
      if (this.windowWidth <= 600) {
        return "col-form-outer col-12 col-md-6 col-lg-6 col-1";
      } else {
        return "col-form-outer col-6 col-md-6 col-lg-6 col-1";
      }
    },
    responsiveClassTwo() {
      if (this.windowWidth <= 600) {
        return "col-form-outer col-12 col-md-6 col-lg-6 col-2";
      } else {
        return "col-form-outer col-6 col-md-6 col-lg-6 col-2";
      }
    },
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  components: {
      Loader,
      TitlePage
  },
  methods:{
    async getIntegrations() {
      // Pegando os campos do layoutWebsite (do Vuex) e adicionando os campos novos desta view
      const layout = this.layoutWebsite;
      if (layout) {
        // this.id = layout.id;
        this.name = layout.nome ?? '';
        this.description = layout.description;
        this.logo = layout.logo;
        this.favicon = layout.favicon;
        this.logoPreview = layout.logoFinal;
        this.faviconPreview = layout.faviconFinal;
        this.url = layout.url;
        this.status = layout.status;
        this.hasReady = true;
        this.activeTheme = layout.typeLayout;
        this.color = layout.color;
           // Campos de integrações (novos ou sobrescrevendo)
      this.facebook = layout.facebookPixelCode;
      this.gads = layout.googleAdsCode;
      this.ganalytic = layout.googleAnalyticsCode;
      this.tagManager = layout.tagManagerCode;
      this.rdrefreshToken = layout.rdrefreshToken;
      this.rdcode = layout.rdcode;
      this.rdSecret = layout.rdsecretClient;
      this.rdClient = layout.rdclienteId;
      this.descriptionAbout = layout.about;
      }

      
    },
    async updateIntegrations() {
      this.hasReady = false;
      // Pegando os campos do layoutWebsite (do Vuex) e sobrescrevendo com os campos atuais do formulário
      const layout = this.layoutWebsite;
      const payload = {
        description: this.description ?? layout.description,
        logo: this.logo ?? layout.logo,
        favicon: this.favicon ?? layout.favicon,
        nome: this.name ?? layout.nome,
        status: this.status ?? layout.status,
        url: this.url ?? layout.url,
        typeLayout: this.activeTheme ?? layout.typeLayout,
        color: this.color ?? layout.color,

        facebookPixelCode: this.facebook,
        googleAdsCode: this.gads,
        googleAnalyticsCode: this.ganalytic,
        tagManagerCode: this.tagManager,
        rdrefreshToken: this.rdrefreshToken,
        rdcode: this.rdcode,
        rdsecretClient: this.rdSecret,
        rdclienteId: this.rdClient,
        about: this.descriptionAbout
      }
      try {
        const responseId = await websiteApi.getWebsite(this.token);
        let idWebsite = responseId.id;
        const response = await websiteApi.editWebsite(this.token, idWebsite, payload);
        this.getIntegrations();
        this.hasReady = true;
        this.notify('Integrações atualizadas com sucesso!', 'success');
      } catch (error) {
        this.notify('Erro ao atualizar integrações.', 'error');
        console.error('Erro ao atualizar dados do website:', error);
      }
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
    notify(message, type = "info") {
            toast(message, {
                autoClose: 3000,
                position: 'top-right',
                theme: "light", 
                limit: 1,
                type: type,
                dangerouslyHTMLString: true
            });
      },
  },
  created() {
    this.getIntegrations()
  }
}
</script>
<style>
@import url('./css/integrations.css');
</style>